import { Grid2, Typography } from "components";
import { useFormContext, useWatch } from "react-hook-form";
import { WebsiteDetails } from "../types";

const PerformanceMetricsSection = () => {
  const form = useFormContext<WebsiteDetails>();

  const performanceMetrics = useWatch({
    control: form.control,
    name: "websiteSection.performanceMetrices",
  });

  const dummyData = [
    { text: "No. of Clients", value: "250+", id: 1 },
    { text: "AUM", value: "100 Cr+", id: 2 },
    { text: "Client Retention Rate", value: "95%", id: 3 },
    { text: "Basket Offered", value: "10+", id: 4 },
  ];

  const metricsData = !performanceMetrics?.performanceMetrics?.every(
    (item) => item.text === "" && item.value === "",
  )
    ? performanceMetrics?.performanceMetrics
    : dummyData;

  return (
    <Grid2
      container
      display={"flex"}
      width={"100%"}
      maxWidth={{ xs: "100vw", md: "1192px" }}
    >
      {metricsData?.map((d) => {
        return (
          <Grid2 size={{ md: 3, xs: 6 }} key={d.id}>
            <Typography
              fontSize={`clamp(1rem, -0.875rem + 6vw, 2.5rem)`}
              fontWeight={700}
              textAlign={"center"}
              whiteSpace={"nowrap"}
              color="#333"
            >
              {d.value}
            </Typography>
            <Typography
              textAlign={"center"}
              whiteSpace={"nowrap"}
              fontSize={`clamp(0.75rem, 0.5938rem + 0.5vw, 0.875rem)`}
              fontWeight={500}
              color="#4F4F4F"
            >
              {d.text}
            </Typography>
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default PerformanceMetricsSection;
